import { render, staticRenderFns } from "./PhyloPicIcon.vue?vue&type=template&id=669cecba&scoped=true"
import script from "./PhyloPicIcon.vue?vue&type=script&lang=js"
export * from "./PhyloPicIcon.vue?vue&type=script&lang=js"
import style0 from "./PhyloPicIcon.vue?vue&type=style&index=0&id=669cecba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "669cecba",
  null
  
)

export default component.exports